import type { PropsOf } from '@emotion/react';
import styled from '@emotion/styled';
import * as tokens from '@tokens';
import { ActionBaseStyles } from '../Actions';

export interface CloseButtonContainerProps extends PropsOf<'button'> {
  /**
   * Should the icon color be inverted
   */
  isColorInverted?: boolean;
}

export const CloseButtonContainer = styled('button', {
  shouldForwardProp: (prop) => prop !== 'isColorInverted',
})<CloseButtonContainerProps>`
  ${ActionBaseStyles};
  color: ${({ isColorInverted }) =>
    isColorInverted
      ? tokens.color.text_disabled_inverse
      : tokens.color.text_disabled};
  &:hover {
    color: ${({ isColorInverted }) =>
      isColorInverted
        ? tokens.color.text_default_inverse
        : tokens.color.text_default};
  }
  svg {
    pointer-events: none;
  }
`;

CloseButtonContainer.defaultProps = {
  type: 'button',
  isColorInverted: false,
};
